import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const PRODUCTS = [{
  name: 'MegaPack Maestría Reiki',
  tagline: 'La formación completa',
  priceReal: '$69.000',
  price: '$19.990',
  checkout: 'https://academiaholisticaargentina.com/cart/48929044562170:1',
  cta: 'Quiero la formación',
  features: ['6 Tomos Profesionales', '6 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato'],
  featured: false
}, {
  name: 'MegaPack Premium',
  tagline: 'La formación + bonos premium',
  priceReal: '$99.000',
  price: '$29.990',
  checkout: 'https://academiaholisticaargentina.com/cart/48966318555386:1',
  cta: 'Quiero la formación premium',
  features: ['Todo lo del MegaPack', 'Bono Premium: Kit Consultor Profesional', 'Bono Premium: Sistema de Consulta Rápida', 'Certificado Digital', 'Acceso Inmediato'],
  featured: true
}];
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1A1625] py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden border-t border-[#342D45]" data-id="element-308">
      <div className="container mx-auto max-w-4xl" data-id="element-309">
        <div ref={ref1} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-310">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-311">
            Elegí comenzar hoy.
          </h2>
          <p className="text-white/60 text-base md:text-lg text-center mb-14 max-w-xl mx-auto" data-id="element-312">
            Elegí el plan que mejor se adapta a tu camino.
          </p>

          {/* Offer cards — compact & professional */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch" data-id="element-313">
            {PRODUCTS.map((p, idx) => <div key={idx} id={p.featured ? 'premium-offer' : undefined} style={p.featured ? {
            scrollMarginTop: '24px'
          } : undefined} className={`relative flex flex-col rounded-3xl p-7 md:p-8 border transition-all duration-300 ${p.featured ? 'bg-[#241F33] border-[#D4AF37] shadow-[0_20px_60px_rgba(212,175,55,0.15)]' : 'bg-[#221D30] border-[#342D45] shadow-[0_15px_40px_rgba(0,0,0,0.35)]'}`} data-id="element-314">
                {p.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-[#1A1625] text-[11px] font-bold px-4 py-1.5 rounded-full uppercase tracking-widest whitespace-nowrap" data-id="element-315">
                    ⭐ Recomendado
                  </span>}

                {/* Header */}
                <div className="text-center mb-6 pt-2" data-id="element-316">
                  <h3 className="text-xl md:text-2xl font-bold text-white leading-tight" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-317">
                    {p.name}
                  </h3>
                  <p className="text-[#D4AF37] text-xs font-semibold uppercase tracking-widest mt-2" data-id="element-318">
                    {p.tagline}
                  </p>
                </div>

                {/* Price */}
                <div className="text-center mb-6" data-id="element-319">
                  <p className="text-white/40 text-sm font-medium line-through mb-1" data-id="element-320">
                    {p.priceReal}
                  </p>
                  <p className="text-4xl md:text-5xl font-extrabold text-white leading-none tracking-tight" data-id="element-321">
                    {p.price}
                  </p>
                  <p className="text-white/50 text-xs font-semibold uppercase tracking-widest mt-2" data-id="element-322">
                    ARS · Pago único
                  </p>
                </div>

                {/* Features */}
                <ul className="space-y-2.5 mb-8 flex-grow" data-id="element-323">
                  {p.features.map((f, i) => <li key={i} className="flex items-center gap-2.5 text-white/90 text-sm font-medium" data-id="element-324">
                      <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#1A1625] flex items-center justify-center border border-[#342D45]" data-id="element-325">
                        <CheckIcon className="w-3 h-3 text-[#D4AF37]" strokeWidth={3} data-id="element-326" />
                      </span>
                      {f}
                    </li>)}
                </ul>

                {/* CTA */}
                <a href={p.checkout} target="_blank" rel="noopener noreferrer" className={`cta-btn w-full block py-4 rounded-xl font-extrabold text-sm md:text-base tracking-wide uppercase text-center transition-all ${p.featured ? 'bg-[#D4AF37] text-[#1A1625] shadow-[0_15px_40px_rgba(212,175,55,0.3)] hover:bg-[#E5C358]' : 'bg-white text-[#1A1625] hover:bg-[#F0EEE8]'}`} style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.04em'
            }} data-id="element-327">
                  {p.cta}
                </a>
              </div>)}
          </div>

          {/* Trust */}
          <div className="mt-12 flex items-center justify-center gap-6 md:gap-10 flex-wrap text-white/60 text-sm font-medium" data-id="element-328">
            <span className="flex items-center gap-2" data-id="element-329">🔒 Pago Seguro</span>
            <span className="flex items-center gap-2" data-id="element-330">🛡 Garantía 7 días</span>
            <span className="flex items-center gap-2" data-id="element-331">💳 Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}